import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('emailAddressField');

    return {
        EMAIL_ADDRESS_FIELD_LABEL: t('emailAddressFieldLabel')
    };
};

export default useTranslation;
